import { useCallback, useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useHistory, useParams } from "react-router-dom";
import { useCurrentMerchantId } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionIcon: {
      color: "white",
      transition: "0.3s",
    },
    listItem: {
      padding: "8px",
      borderRadius: "8px 0px 0px 8px",
      color: "white",
      borderLeft: `3px solid transparent`,
      borderTop: `3px solid transparent`,
      borderBottom: `3px solid transparent`,
      cursor: "pointer",
      transition: "0.3s",
      "&:hover": {
        backgroundColor: "#ddd",
        borderColor: "#ccc",
        borderRight: "none",
        color: "#666",
        "& $sectionIcon": {
          color: "#666",
        },
      },
    },
    active: {
      borderColor: `${theme.palette.primary.main}!important`,
      backgroundColor: "#eee!important",
      color: "black!important",
      "& $sectionIcon": {
        color: "black!important",
      },
    },
  }),
);

const useMerchantListItem = (sectSlug: string) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();

  const history = useHistory();

  const merchantId = useCurrentMerchantId();

  const onClicked = useCallback(() => {
    history.replace(`/merchants/${merchantId}/${sectSlug}/`);
  }, [history, merchantId, sectSlug]);

  return {
    styles,
    classes,
    atomicStyles,
    onClicked,
  };
};

export { useMerchantListItem as default };
